export enum GoogleRecaptchaTheme {
    Light = 'Light',
    Dark = 'Dark'
}

export enum CloudflareRecaptchaTheme {
    light = 'light',
    dark = 'dark'
}